import Vue from 'vue'
// import * as validators from 'vuelidate/lib/validators'
import required from 'vuelidate/lib/validators/required'
//import between from 'vuelidate/lib/validators/between'
import email from 'vuelidate/lib/validators/email'
//import {withParams} from 'vuelidate/lib/validators'
import _ from 'lodash'
import numeral from 'numeral'

numeral.locale('de')
var validators = {}
var errorMsg = {}

//=======================================================================================================
errorMsg.required = (key, $v) => {
    var msg = 'Pflichtfeld'
    return msg
}
validators.required = required
//=======================================================================================================
errorMsg.email = (key, $v) => {
    var msg = 'kein gültiges eMail Format'
    return msg
}

validators.email = email
//=======================================================================================================
errorMsg.betweenIf3 = (key, $v, cfg) => {
    console.log("testBIF1 A1%%%%%%% betweenIf3 msg - key:", key)
    console.log("testBIF1 A2%%%%%%% betweenIf3 msg - v:", key, $v)
    console.log("testBIF1 A3%%%%%%% betweenIf3 msg - cfg:", cfg)
    var params = cfg['betweenIf3']
    console.log("testBIF1 A4%%%%%%% betweenIf3: params", params)
    var component = $v.$model
    console.log("testBIF1 A5%%%%%%% betweenIf3: component", component)


    var got_a_set_match = false
    var min = 0
    var max = 0
    _.forEach(params, function (set, index) {


        //..........................................................................
        if ("IF" in set) {
            var check = true
            _.forEach(set['IF'], function (conditional_field_value, conditional_field_name) {
                var current_field_value = component[conditional_field_name]
                check = check && (current_field_value === conditional_field_value)
                console.log("testBIF1 field:", conditional_field_name, "/C:", check, "/ ist: ", current_field_value, "/ soll: ", conditional_field_value, "/ vergleich: ", current_field_value === conditional_field_value)
            })
            if (check == true) {
                min = set.min
                max = set.max
                got_a_set_match = true
                console.log("testBIF1 set " + index + ": all true take this min (" + min + ") and max(" + max + ")")

                return
            } else {
                console.log("testBIF1 set " + index + ": at least one condition false - skip this min/max")
            }

            //..........................................................................
        } else if (("ELSE" in set)) {
            if (got_a_set_match == false) {
                min = set.min
                max = set.max
                console.log("testBIF1 set 'ELSE': NO set_match before -> take ELSE-min (" + min + ") and -max(" + max + ")")
            } else {
                console.log("testBIF1 set 'ELSE': skipped, got_a_set_match before")
            }

            //..........................................................................
        } else {
            console.log("testBIF1 ERROR !!! -> no IF or ELSE keys in config ?!?")

        }//.............................................................................
    })


    var msg = 'Zahl zwischen ' + min + ' und ' + max
    return msg
}
//---------------------------------------------------------------------------------
validators.betweenIf3 = (params) => {
    console.log("testBIF1_check 1%%%%%%% p,t,v", params)
    return (value, component) => {
        console.log('testBIF1_check betweenIf3: v:', value, 'comp:', component, 'params:', params, 'this:', this)

        var myNumeral = numeral(value)
        var DB_value = myNumeral.value()
        console.log("testBIF1_check fieldVal:", DB_value, "/ params: ", params)
        var got_a_set_match = false
        var min = 0
        var max = 0
        _.forEach(params, function (set, index) {


            //..........................................................................
            if ("IF" in set) {
                var check = true
                _.forEach(set['IF'], function (conditional_field_value, conditional_field_name) {
                    var current_field_value = component[conditional_field_name]
                    check = check && (current_field_value === conditional_field_value)
                    console.log("testBIF1_check field:", conditional_field_name, "/C:", check, "/ ist: ", current_field_value, "/ soll: ", conditional_field_value, "/ vergleich: ", current_field_value === conditional_field_value)
                })
                if (check == true) {
                    min = set.min
                    max = set.max
                    got_a_set_match = true
                    console.log("testBIF1_check set " + index + ": all true take this min (" + min + ") and max(" + max + ")")

                    return
                } else {
                    console.log("testBIF1_check set " + index + ": at least one condition false - skip this min/max")
                }

                //..........................................................................
            } else if (("ELSE" in set)) {
                if (got_a_set_match == false) {
                    min = set.min
                    max = set.max
                    console.log("testBIF1_check set 'ELSE': NO set_match before -> take ELSE-min (" + min + ") and -max(" + max + ")")
                } else {
                    console.log("testBIF1_check set 'ELSE': skipped, got_a_set_match before")
                }

                //..........................................................................
            } else {
                console.log("testBIF1_check ERROR !!! -> no IF or ELSE keys in config ?!?")

            }//.............................................................................
        })
        //


        if (min <= DB_value && DB_value <= max) {
            return true
        } else {
            return false
        }


    }
}
/*
"required",
"integer",
{"betweenIf3If2":[{"uvr_pers__1__beruf":"773-K","min":0,"max":50},
              {"ELSE":"",                  "min":0,"max":100}]}

*/
//=======================================================================================================
errorMsg.betweenIf = (key, $v, cfg) => {
    console.log("testBIF2_msg =============================================================")
    console.log("testBIF2_msg A1%%%%%%% betweenIf msg - key:", key)
    console.log("testBIF2_msg A2%%%%%%% betweenIf msg - v:", key, $v)
    console.log("testBIF2_msg A3%%%%%%% betweenIf msg - cfg:", cfg)
    var params = cfg['betweenIf']
    console.log("testBIF2_msg A4%%%%%%% betweenIf: params", params)
    var component = $v.$model
    console.log("testBIF2_msg A5%%%%%%% betweenIf: component", component)


    /*
    "integer",
{"betweenIf":[{"IF":[["uvr_pers__1__betrag_kt_geld_15",">","0"],
                     ["uvr_pers__1__alter","=>","18"]           ],"min":"5","max":"150","MSG" :"Muss 0 oder zwischen <min> und <max> sein"},
              {"ELSE":null                                      ,"min":"0","max":"0","MSG" :"Muss für Minderjährige 0 sein"}
             ]
}
    * */
    var got_a_set_match = false
    var min = 0
    var max = 0
    var special_msg = ""
    _.forEach(params, function (set, index) {

        console.log("testBIF2_msg_______________________________________________", set)
        //..........................................................................
        var subSet = "weder IF noch ELSEIF"
        if ("IF" in set) {
            var subSet = set['IF']
        } else if ("ELSEIF" in set) {
            var subSet = set['ELSEIF']
        }


        if (component[set.min] !== undefined) {
            var myNumeral = numeral(component[set.min])
            min = myNumeral.value()
        } else {
            min = set.min
        }
        if (component[set.max] !== undefined) {
            var myNumeral = numeral(component[set.max])
            max = myNumeral.value()
        } else {
            max = set.max
        }


        if (subSet !== "weder IF noch ELSEIF") { // ein IF oder ELSEIF set:
            var conditional_result = true
            _.forEach(subSet, function (conditional_group, setNo) {
                console.log("testBIF2_msg...........................................", subSet)
                console.log("testBIF2_msg IF-Set-Nr " + index + "/" + setNo + " / zwi-Ergebnis: ", conditional_result)

                var conditional_field_name = conditional_group[0]
                var conditional_operator = conditional_group[1]
                var conditional_field_value = conditional_group[2]
                var current_field_value = component[conditional_field_name]


                if (conditional_operator == "<") {
                    var conditional_partial_result = (current_field_value < conditional_field_value)
                } else if (conditional_operator == ">") {
                    var conditional_partial_result = (current_field_value > conditional_field_value)
                } else if (conditional_operator == ">=") {
                    var conditional_partial_result = (current_field_value >= conditional_field_value)
                } else if (conditional_operator == "<=") {
                    var conditional_partial_result = (current_field_value <= conditional_field_value)
                } else {
                    var conditional_partial_result = (current_field_value === conditional_field_value)
                }
                conditional_result = conditional_result && conditional_partial_result
                console.log("testBIF2_msg IF-Set-Nr " + index + "/" + setNo + " field:", conditional_field_name, "/ Vergleich ist: ", current_field_value, conditional_operator, " soll: ", conditional_field_value, "/ teil-Ergebnis:", conditional_partial_result, "/ zwi-Ergebnis:", conditional_result)
            })
            console.log("testBIF2_msg field: SubSet-End-Ergebnis:", conditional_result)
            if (conditional_result == true) {

                special_msg = set.MSG
                got_a_set_match = true
                console.log("testBIF2_msg set " + index + ": all true take this SubSets min (" + min + ") and max(" + max + ")")
                return false; //BREAK forEach, da ein gültiges IF gefunden wurde

            } else {
                console.log("testBIF2_msg set " + index + ": at least one condition false - skip this min/max-SubSet")
            }

            //..........................................................................
        } else if (("ELSE" in set)) {
            if (got_a_set_match == false) {

                special_msg = set.MSG
                console.log("testBIF2_msg set 'ELSE': NO set_match before -> take ELSE-min (" + min + ") and -max(" + max + ")")
            } else {
                console.log("testBIF2_msg set 'ELSE': skipped, got_a_set_match before")
            }

            //..........................................................................
        } else if (("MSG" in set)) {
            //SKIP (Message-Text)
            //..........................................................................
        } else {
            console.log("testBIF2_msg ERROR !!! -> no IF or ELSE keys in config ?!?")

        }//.............................................................................
    })
    if (special_msg > '') {
        var msg = special_msg
        msg = msg.replace('<min>', min)
        msg = msg.replace('<max>', max)

    } else {
        var msg = 'Zahl zwischen ' + min + ' und ' + max
    }

    return msg
}
//-------------------------------------------------------------------------------------------------------------------------------------------------------------
validators.betweenIf = (params) => {
    //   console.log("testBIF2_check %%%%%%% p,t,v", params)
    return (value, component) => {
        // console.log('testBIF2_check betweenIf: v,c,p,t', value, component, params, this)

        var myNumeral = numeral(value)
        var DB_value = myNumeral.value()
        console.log("testBIF2_check =============================================================")
        console.log("testBIF2_check fieldVal:", DB_value, "/ params: ", params)
        var got_a_set_match = false
        var min = 0
        var max = 0
        _.forEach(params, function (set, index) {
            console.log("testBIF2_check_________________________________________", set)

            //..........................................................................
            var subSet = "weder IF noch ELSEIF"
            if ("IF" in set) {
                var subSet = set['IF']
            } else if ("ELSEIF" in set) {
                var subSet = set['ELSEIF']
            }

            if (component[set.min] !== undefined) {
                var myNumeral = numeral(component[set.min])
                min = myNumeral.value()
            } else {
                min = set.min
            }
            if (component[set.max] !== undefined) {
                var myNumeral = numeral(component[set.max])
                max = myNumeral.value()
            } else {
                max = set.max
            }

            if (subSet !== "weder IF noch ELSEIF") { // ein IF oder ELSEIF set:

                var conditional_result = true
                _.forEach(subSet, function (conditional_group, setNo) {
                    console.log("testBIF2_check...........................................", subSet)
                    console.log("testBIF2_check IF-Set-Nr " + index + "/" + setNo + " / zwi-Ergebnis: ", conditional_result)
                    var conditional_field_name = conditional_group[0]
                    var conditional_operator = conditional_group[1]
                    var conditional_field_value = conditional_group[2]
                    var current_field_value = component[conditional_field_name]


                    if (conditional_operator == "<") {
                        var conditional_partial_result = (current_field_value < conditional_field_value)
                    } else if (conditional_operator == ">") {
                        var conditional_partial_result = (current_field_value > conditional_field_value)
                    } else if (conditional_operator == ">=") {
                        var conditional_partial_result = (current_field_value >= conditional_field_value)
                    } else if (conditional_operator == "<=") {
                        var conditional_partial_result = (current_field_value <= conditional_field_value)
                    } else {
                        var conditional_partial_result = (current_field_value === conditional_field_value)
                    }
                    conditional_result = conditional_result && conditional_partial_result
                    console.log("testBIF2_check IF-Set-Nr " + index + "/" + setNo + " field:", conditional_field_name, "/ Vergleich ist: ", current_field_value, conditional_operator, " soll: ", conditional_field_value, "/ teil-Ergebnis:", conditional_partial_result, "/ zwi-Ergebnis:", conditional_result)
                })
                if (conditional_result == true) {

                    got_a_set_match = true
                    console.log("testBIF2_check all sets result: " + index + ": all in SubSet true take this SubSets min (" + min + ") and max(" + max + ")")
                    return false; //BREAK forEach, da ein gültiges IF gefunden wurde
                } else {
                    console.log("testBIF2_check all sets result: " + index + ": at least one condition false - skip this SubSet-min/max")
                }

                //..........................................................................
            } else if (("ELSE" in set)) {
                if (got_a_set_match == false) {

                    console.log("testBIF2_check set 'ELSE': NO set_match before -> take ELSE-min (" + min + ") and -max(" + max + ")")
                } else {
                    console.log("testBIF2_check set 'ELSE': skipped, got_a_set_match before")
                }

                //..........................................................................
            } else {
                console.log("testBIF2_check ERROR !!! -> no IF or ELSE keys in config ?!?")

            }//.............................................................................
            console.log('testBIF2_check Set-Loop Bottom')
        })
        //

        console.log('testBIF2_check full result:', min, '<=', DB_value, '<=', max, ' = ', (min <= DB_value && DB_value <= max))
        if (min <= DB_value && DB_value <= max) {

            return true
        } else {
            return false
        }


    }
}
/*
"required",
"integer",
{"betweenIfIf2":[{"uvr_pers__1__beruf":"773-K","min":0,"max":50},
              {"ELSE":"",                  "min":0,"max":100}]}

*/

//=======================================================================================================
errorMsg.between = (key, $v, validateArray) => {
    // console.log("1X%%%%%%% between: key,v,p,valStr", key, $v, validateString)
    var params = validateArray['between']
    // console.log("1X%%%%%%% between: params", params)
    var msg = 'Zahl zwischen ' + params.min + ' und ' + params.max
    return msg
}
//---------------------------------------------------------------------------------
validators.between = (params) => {
    // console.log("1a%%%%%%% p,t,v", params)
    return (value, component) => {
        // console.log('1b%%%%%%% between: v,c,p,t', value, component, params, this)

        var myNumeral = numeral(value)
        var DB_value = myNumeral.value()

        if (params.min <= DB_value && DB_value <= params.max) {
            return true
        } else {
            return false
        }
    }
}
//=======================================================================================================
errorMsg.integer = (key, $v) => {
    var msg = 'ganze Zahl!'
    return msg
}
validators.integer = (value, component) => {
    // console.log('1a%%%%%%% integer: v,c,t', value, component, this)
    if (value > '' && value !== '-/-') {
        var parsedInt = parseInt(value, 10)
        // console.log('1b%%%%%%% integer: v,Int, bool', numeral(value).format('0,'), value.toString(), numeral(value).format('0,') === value.toString())
        // console.log('1c%%%%%%% integer: v,Int, bool', parsedInt.toString(), value.toString(), parsedInt.toString() === value.toString())
        if (!(parsedInt.toString() === value.toString() || numeral(value).format('0,') === value.toString())) {
            return false
        }
    }
    return true
}
//=======================================================================================================
errorMsg.float = (key, $v) => {
    var msg = 'eine Zahl!'
    return msg
}
validators.float = (value, component) => {
    // console.log('1a%%%%%%% currency: v,c,t', value, component, this)
    if (value > '' && value !== '-/-') {
        var isFloat = /^[0-9]\d*(((\.\d{3}){1})*(,\d{1,10})?)$/.test(value)

        if (!(isFloat)) {
            // console.log('1d%%%%%%% => ', isFloat)
            return false
        }
    }
    // console.log('1e%%%%%%%')
    return true
}
//=======================================================================================================
errorMsg.currency = (key, $v) => {
    var msg = 'Währungs-Betrag!'
    return msg
}
validators.currency = (value, component) => {
    // console.log('1a%%%%%%% currency: v,c,t', value, component, this)
    if (value > '' && value !== '-/-') {
        var isFloat = /^[0-9]\d*(((\.\d{3}){1})*(,\d{1,2})?)$/.test(value)

        if (!(isFloat)) {
            // console.log('1d%%%%%%% currency')
            return false
        }
    }
    // console.log('1e%%%%%%% currency')
    return true
}
//=======================================================================================================
errorMsg.plz = (key, $v) => {
    var msg = 'fünfstellige PLZ'
    return msg
}
validators.plz = (value, component) => {
    // console.log('1a%%%%%%% plz: v,c,t', value, component, this)
    if (value > '' && value !== '-/-') {
        var is5Numbers = /^\d{5}$/.test(value)
        if (is5Numbers && parseInt(value, 10) > 0 && parseInt(value, 10) < 99999) {
            return true
        } else {
            return false
        }
    }
    // console.log('1e%%%%%%% plz')
    return true
}
//=======================================================================================================
errorMsg.iban = (key, $v) => {
    var msg = 'keine gültige 22-stellige IBAN ?!?'
    return msg
}
validators.iban = (value, component) => {
    if (value === '-/-') {
        return true
    }
    if (value && value.length === 22) {


        /*
        if (IBAN_info) {
          // console.log('IBAN_info :', IBAN_info)
          //component.bank_bic = data.bankData.bic
          //component.bank_institut = data.bankData.name.replace(data.bankData.city, '') + ' ' + data.bankData.city
          component.bank_bic = IBAN_info.data.swift_code
          component.bank_institut = IBAN_info.data.bank.replace(IBAN_info.data.city, '') + ' ' + IBAN_info.data.city
          //resolve(data.valid)
          // console.log('valid ? => ', IBAN_info.validation.iban_validity === 'Valid')
          return (IBAN_info.validation.iban_validity === 'Valid')
        }
        */

        return new Promise((resolve, reject) => {
            //var url = 'https://openiban.com/validate/' + value + '?validateBankCode=true&getBIC=true'
            var url = 'https://api.bank.codes/iban/?format=json&api_key=e9579941c4366c17da3ef7d8fcd1e537&iban=' + value
            Vue.http.get(url).then(response => {
                // console.log('IBAN response:', response.body)
                var IBAN_info = response.body.result
                if (IBAN_info) {
                    // console.log('IBAN_info :', IBAN_info)
                    var isValid = IBAN_info.validation.iban_validity === 'Valid'

                    if (isValid) {
                        // console.log('IBAN-API result is valid => update bank-Data & return TRUE')
                        //component.bank_bic = data.bankData.bic
                        //component.bank_institut = data.bankData.name.replace(data.bankData.city, '') + ' ' + data.bankData.city
                        component.bank_bic = IBAN_info.data.swift_code
                        component.bank_institut = IBAN_info.data.bank.replace(IBAN_info.data.city, '') + ' ' + IBAN_info.data.city

                    } else {
                        // console.log('IBAN-API result is invalid => return FALSE')
                    }
                    //resolve(data.valid)
                    //nur wenn die Validierung der IBAN-API expilzit 'invalid' liefert, wird die Validierung 'false' :
                    resolve(isValid)
                } else {
                    //trotz Fehler return 'true' - da evtl. IBAN-API ausgefallen ist und user dennoch weitermachen können muss
                    // console.log('IBAN-API: not expected Data -  but return "valid" anyway (user can continue)')
                    resolve(true)
                }

            }, response => {
                // console.log('IBAN DATA ! ERROR ! :', response)
                //trotz Fehler return 'true' - da evtl. IBAN-API ausgefallen ist und user dennoch weitermachen können muss
                // console.log('IBAN-API: XHR error -  but return "valid" anyway (user can continue)')
                resolve(true)
            })
        })

    } else {
        return false
    }
}

//=======================================================================================================
errorMsg.noValidation = () => ''
//-----------------------------------------------------
validators.noValidation = (value, component) => {
    return true
}
//=======================================================================================================
errorMsg.keinWeichdach = () => 'nicht versicherbar'
//-----------------------------------------------------
validators.keinWeichdach = (value, component) => {
    if (value === 'WD') {
        return false
    } else {
        return true
    }
}
//=======================================================================================================
errorMsg.nurFeuerfest = () => 'BAK3/4/5 & FHG3 nicht versicherbar'
//-----------------------------------------------------
validators.nurFeuerfest = (value, component) => {
    if (value === 'BAK3') {
        return false
    } else if (value === 'BAK4') {
        return false
    } else if (value === 'BAK5') {
        return false
    } else if (value === 'FHG3') {
        return false
    } else {
        return true
    }
}
//=======================================================================================================
errorMsg.keinDenkmal = () => 'Gebäude unter Denkmalschutz sind nicht versicherbar'
//-----------------------------------------------------
validators.keinDenkmal = (value, component) => {
    if (parseInt(value, 10) === 1) {
        // console.log("=> false")
        return false
    } else {
        // console.log("=> true")
        return true
    }

}
//=======================================================================================================
errorMsg.keinFerienhaus = () => 'WE- und Ferien-Häuser sind nicht versicherbar'
//-----------------------------------------------------
validators.keinFerienhaus = (value, component) => {
    if (parseInt(value, 10) === 1) {
        return false
    } else {
        return true
    }

}
//=======================================================================================================
errorMsg.stetsBewohnt = () => 'Nicht durchgängig bewohnte Objekte können nicht versichert werden'
//-----------------------------------------------------
validators.stetsBewohnt = (value, component) => {
    if (parseInt(value, 10) === 0) {
        return false
    } else {
        return true
    }

}
//=======================================================================================================
errorMsg.keineFeuergefahr = () => 'Dieses Risiko ist nicht versicherbar'
//-----------------------------------------------------
validators.keineFeuergefahr = (value, component) => {
    if (parseInt(value, 10) === 1) {
        return false
    } else {
        return true
    }

}
//=======================================================================================================
errorMsg.mussJa = () => 'nur bei "ja" ist ein Vertragabschluss möglich'
//-----------------------------------------------------
validators.mussJa = (value, component, x) => {
    // console.log("mussJa", parseInt(value, 10) === 1, parseInt(value, 10), 1)
    if (parseInt(value, 10) === 1) {
        return true
    } else {
        return false
    }

}
//=======================================================================================================
errorMsg.mussNein = () => 'nur bei "nein" kann versichert werden'
//-----------------------------------------------------
validators.mussNein = (value, component) => {
    if (parseInt(value, 10) === 0) {
        return true
    } else {
        return false
    }

}
//=======================================================================================================
errorMsg.datum = () => 'Format muss "TT.MM.JJJJ" sein'
//-----------------------------------------------------
validators.datum = (value, component) => {
    // var valid = /^\d{2}\.\d{2}\.\d{4}$/.test(value);

    var valid = false
    var matches = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value)
    // console.log("matches", matches)
    if (matches) {
        var d = parseInt(matches[1], 10)
        var m = parseInt(matches[2] - 1, 10)
        var y = parseInt(matches[3], 10)
        var composedDate = new Date(y, m, d)
        // console.log("composedDate", composedDate)
        valid = composedDate.getDate() === d &&
            composedDate.getMonth() === m &&
            composedDate.getFullYear() === y
    }

    if (value === "-/-") {
        valid = true
    }
    if (valid) {
        return true
    } else {
        return false
    }
}
//=======================================================================================================
errorMsg.minDateTomorrow = () => 'Datum muss in Zukunft liegen'
//-----------------------------------------------------
validators.minDateTomorrow = (value, component) => {
    var valid = false
    var date_tomorrow = window.moment().startOf('day').add(1, 'days')
    var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
    valid = (date_tomorrow <= date_input)

    // console.log("**** VALID? ***", valid, date_tomorrow.format("DD.MM.YYYY"), date_input.format("DD.MM.YYYY"));
    // console.log(date_tomorrow);
    // console.log(date_input);

    if (valid) {
        return true
    } else {
        return false
    }
}
//=======================================================================================================
errorMsg.DateMax2YearsAgo = () => 'Das Datum darf maximal 2 Jahre in der Vergangenheit liegen'
//-----------------------------------------------------
validators.DateMax2YearsAgo = (value, component) => {
    var valid = false

    if (value && (value + '').length === 4 && parseInt(value, 10) > 1900 && parseInt(value, 10) < 2999) {
        value = '31.12.' + value

    }
    var date_input = window.moment(value, 'DD.MM.YYYY')
    var date_min = window.moment().subtract(24, 'months')

    valid = (date_min <= date_input)
    // console.log("** VALID? ***", valid, date_min.format("DD.MM.YYYY"), date_input.format("DD.MM.YYYY"));
    // console.log(date_min);
    // console.log(date_input);

    return valid

}

//=======================================================================================================
errorMsg.jahresZahl = () => 'vierstellige Jahreszahl'
//-----------------------------------------------------
validators.jahresZahl = (value, component) => {

    var valid = false
    // console.log("*** VALID? VALUE: ***", value);
    if (value === '-/-') {
        return valid
    }
    // console.log("check:", value, (value ? (value + '').length === 4 : '?'), parseInt(value, 10) > 1900, parseInt(value, 10) < 2999);

    if (value && (value + '').length === 4 && parseInt(value, 10) > 1900 && parseInt(value, 10) < 2999) {

        valid = true
    } else {

    }
    // console.log("** VALID Result :", valid);
    return valid
}
//=======================================================================================================
errorMsg.vorschaden_anz_max = (key, $v, validateArray) => {
    // console.log("999a%%%%%%% vorschaden_anz_max: key,v,p,valStr: ", key, $v, validateArray)
    var params = validateArray['vorschaden_anz_max']
    var vertrag_sparte = $v.$model['vertrag_sparte']
    if (params[vertrag_sparte] > 0) {
        msg = 'Versicherung nicht möglich (max. Anzahl an Vorschäden: ' + params[vertrag_sparte] + ')'
    } else {
        var msg = ''
    }

    return msg
}
//-----------------------------------------------------
validators.vorschaden_anz_max = (params) => {
    // console.log("999b%%%%%%% p,t,v: ", params)
    return (value, component) => {
        // console.log('999c %%%%%%% between: v,c,p,t: ', value, component, params, this)

        var myNumeral = numeral(value)
        var DB_value = myNumeral.value()
        var vertrag_sparte = component.vertrag_sparte

        var maxAnz = params[vertrag_sparte]
        if (maxAnz != null) {
            if (DB_value <= maxAnz) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }
    }
}
//=======================================================================================================
errorMsg.hr_minSum = (key, $v, validateArray) => {
    console.log("(vali-hr_minSum-a) vorschaden_anz_max: key,v,vAr: ", key, $v, validateArray)
    var qm = $v.$model['hr_qm']
    //var verSum = $v.$model['hr_vers_summe']
    //var minSum = numeral(qm * 650 * 0.5 / 100).format("0") * 100


    var msg = 'Die Versicheruns-Summe ist für '+ qm +'m² zu gering'

    return msg
}
//-----------------------------------------------------
validators.hr_minSum = (value, component) => {

    console.log('(vali-hr_minSum-c) between: v,c,t: ', value, component, this)
    console.log('(vali-hr_minSum-d) hr_jn_untervers_schutz: ', component.hr_jn_untervers_schutz)

    if (component.hr_jn_untervers_schutz == 1) {
        return true
    } else {

        var qm = component.hr_qm
        var verSum = numeral(component.hr_vers_summe).value() // component.hr_vers_summe
        var minSum = numeral(numeral(component.hr_qm).value() * 650 * 0.5 / 100).format("0") * 100

        console.log('(vali-hr_minSum-e) minSum ' + minSum + ' / VersSum: ' + verSum + ' / qm: ' + qm)

        if (verSum < minSum) {
            console.log('(vali-hr_minSum-f) -> error')
            return false
        } else {
            console.log('(vali-hr_minSum-f) -> NO error')
            return true
        }

    }
}

//=======================================================================================================
errorMsg.vorschaden_sum_max = (key, $v, validateArray) => {
    // console.log("777a%%%%%%% vorschaden_anz_max: key,v,p,valStr: ", key, $v, validateArray)
    var params = validateArray['vorschaden_sum_max']
    var vertrag_sparte = $v.$model['vertrag_sparte']
    if (params[vertrag_sparte] > 0) {
        msg = 'Versicherung nicht möglich (max. Höhe der Vorschäden: ' + params[vertrag_sparte] + '€)'
    } else {
        var msg = ''
    }

    return msg
}
//-----------------------------------------------------
validators.vorschaden_sum_max = (params) => {
    // console.log("777b%%%%%%% p,t,v: ", params)
    return (value, component) => {
        // console.log('777c %%%%%%% between: v,c,p,t: ', value, component, params, this)

        var myNumeral = numeral(value)
        var DB_value = myNumeral.value()
        var vertrag_sparte = component.vertrag_sparte

        var maxSum = params[vertrag_sparte]
        if (maxSum != null) {
            if (DB_value <= maxSum) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }
    }
}

//=======================================================================================================

errorMsg.radPreisLimits = (key, $v, validateArray) => {

    // console.log("123X%%%%%%% between: key,v,p,valStr", key, $v, validateArray)


    // neue Version seit 1.12021:
    var msg = 'Räder über  12.000€ nur auf Anfrage versicherbar'

    /* alte Version bis 1.12021:
     var index = key.substr(key.length - 1)
     var kat = $v.$model['raeder_ARRAY_kategorie_' + index]
     if (kat === "KatBike" || kat === "KatRollstuhl") {
         var msg = 'Kaufpreis bis 10.000€'

     } else if (kat === "KatTeilCarbon") {
         var msg = 'Kaufpreis bis 4.000€'

     } else if (kat === "KatCarbon") {
         var msg = 'Kaufpreis von 4.000€ bis 20.000€'

     } else {
         var msg = '???'
     }
     */


//var params = validateArray['between']
// console.log("1X%%%%%%% between: params", params)

    return msg
}
//-----------------------------------------------------
validators.radPreisLimits = (value, component) => {

    var valid = true
    var numberValue = numeral(value).value()
    // console.log('*** radPreisLimits ***', numberValue, component.raeder_ARRAY_kategorie_1)


    // neue Version seit 1.12021:
    if (numberValue < 1 || 12000 < numberValue) {
        valid = false
    }

    /* alte Version bis 1.12021:
    var kat = component.raeder_ARRAY_kategorie_1

 if ((kat === "KatBike" || kat === "KatRollstuhl") && (10000 < numberValue)) {
     // console.log("kategorie_1 === Bike/Rollstuhl & Preis > 100000");
     valid = false
 }
 if ((kat === 'KatTeilCarbon') && (4000 <= numberValue)) {
     // console.log('kategorie_1 === KatCarbon & Preis not 4000-20000')
     valid = false
 }
 if ((kat === 'KatCarbon') && (numberValue < 4000 || 20000 < numberValue)) {
     // console.log('kategorie_1 === KatCarbon & Preis not 4000-20000 => ', numberValue)
     valid = false
 }
*/


    return valid
}


//=======================================================================================================

errorMsg.mussA_wennB_gleichC = (key, $v, validateArray) => {
    // console.log("ABC b%%%%%%% mussA_wennB_gleichC => key:", key, '/v:', $v, '/validateArray:', validateArray)
    var params = validateArray['mussA_wennB_gleichC']
    var msg = params['errMsg']
    return msg
}
//-----------------------------------------------------
validators.mussA_wennB_gleichC = (params) => {
    // console.log("ABC a %%%%%%% p,t,v: ", params)
    return (value, component) => {

        // console.log('ABC b %%%%%%% mussA_wennB_gleichC: v:', value, '/c:', component, '/p:', params, "/t:", this)

        // var myNumeral = numeral(value)
        var ist_Wert_A = value + ""
        var muss_Wert_A = params.muss + ""
        var ist_Wert_B = component[params.wenn] + ""

        console.log("§§§ TEST: ", ist_Wert_B == soll_Wert_C, ist_Wert_B, soll_Wert_C)
        var valid = true


        if (ist_Wert_A == muss_Wert_A) { //wenn A eh schon Soll-Wert hat, muss gar nicht erst B und C geprüft werden:

            valid = true
        } else {//Wenn A nicht den SollWert hat, dann prüfen , ob es ihn haben sollte:
            //...................................................
            if (typeof params.gleich !== 'undefined') {
                console.log("§§§ TEST: check 'gleich'")
                var soll_Wert_C = params.gleich + ""
                if (ist_Wert_B == soll_Wert_C) {
                    valid = false
                } else {
                    valid = true
                }
            }
            //...................................................
            if (typeof params.grosser !== 'undefined') {
                console.log("§§§ TEST: check 'grosser' for" + ist_Wert_B + " > " + soll_Wert_C)
                var soll_Wert_C = params.grosser + ""
                if (ist_Wert_B > soll_Wert_C) {
                    valid = false
                } else {
                    valid = true
                }
            }
            //...................................................
        }

        // console.log("(4) valid",valid)
        return valid
    }
}

//=======================================================================================================

errorMsg.requiredIfAny = () => 'Pflichtfeld!'
//-----------------------------------------------------
validators.requiredIfAny = (params) => {
    // console.log('1a%%%%%%%', params)
    return (value, component) => {
        // console.log('1b%%%%%%% v,c,p,t', value, component, params, this)
        var required = false
        _.forEach(params, function (value, key) {
            // console.log('%%%%%%% (component[' + key + '])', String(component[key]), String(value))
            required = required || (String(component[key]) === String(value))
        })

        var valid = !(required === true && !value)
        // console.log('%%%%%%% requiredIf required:', required, 'valid:', valid)
        return valid
    }
}
//=======================================================================================================
errorMsg.VertragBeginNotEmpty = () => "Feld 'Vertragsbeginn' nötig"
//-----------------------------------------------------
validators.VertragBeginNotEmpty = (value, component) => {
    // console.log("@@@@@@@@@@ VertragBeginNotEmpty:", value, "|", component.vertrag_beginn, "|")
    var valid = false
    if (component.vertrag_beginn && component.vertrag_beginn > '') {
        valid = true
    }
    return valid

}

//=======================================================================================================
errorMsg.ageMin = (key, $v, validateArray) => {
    console.log("ageMin 1%%%%%%% ageMin: key:", key, "/v:", $v, "/valArray:", validateArray)
    var params = validateArray['ageMin']
    console.log("ageMin 2X%%%%%%% between: params: ", params)
    var msg = 'Mindestalter ' + params.min + ' zu Vertragsbeginn'
    return msg
}
//----------------------------------------------------------------------------
validators.ageMin = (params) => {
    console.log("ageMin 3%%%%%%% p:", params)
    return (value, component) => {
        console.log('ageMin 4%%%%%%% ageMin: v:', value, ",/c:", component, "/p:", params, "/this:", this)

        var valid = false
        var date_contract = window.moment(component.vertrag_beginn, 'DD.MM.YYYY').startOf('day')
        var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
        var date_minAge_birthday = window.moment(date_input, 'DD.MM.YYYY').add(params.min, 'years')
        console.log("ageMin 5a@@@@@@@@@@ date_contract", date_contract)
        console.log("ageMin 5b@@@@@@@@@@ date_input", date_input)

        valid = (date_minAge_birthday <= date_contract)

        console.log('ageMin 6**** VALID? *** 64. Geburtstag:', date_minAge_birthday.format("DD.MM.YYYY"), "<=  vertrBeginn", date_contract.format("DD.MM.YYYY"), '? =>', valid);

        return valid
    }
}

//=======================================================================================================
errorMsg.ageMax = (key, $v, validateArray) => {
    // console.log("1X%%%%%%% ageMax: key,v,p,valStr", key, $v, validateString)
    var params = validateArray['ageMax']
    // console.log("1X%%%%%%% between: params", params)
    var msg = 'Höchstalter ' + params.max + ' zu Vertragsbeginn'
    return msg
}
//----------------------------------------------------------------------------
validators.ageMax = (params) => {
    // console.log("[ageMax] 1%%%%%%% p,t,v", params)
    return (value, component) => {
        // console.log('[ageMax] 2%%%%%%% ageMax: v,c,p,t', value, component, params, this)

        var valid = false
        var date_contract = window.moment(component.vertrag_beginn, 'DD.MM.YYYY').startOf('day')
        var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
        var date_maxAge_birthday = window.moment(date_input, 'DD.MM.YYYY').add(params.max, 'years')
        // console.log("[ageMax] 3@@@@@@@@@@", date_contract, date_input, component.uvr_altersgruppe)

        valid = (date_maxAge_birthday >= date_contract)

        // console.log('**** VALID? *** 64. Geburtstag:', date_is67.format("DD.MM.YYYY"), "<=  vertrBeginn", date_contract.format("DD.MM.YYYY"), '? =>', valid);
        // console.log("[ageMax] 4 result => " + (valid*1))

        return valid
    }
}

//=======================================================================================================
errorMsg.ageSeniorenMin = (key, $v, validateArray) => {
    return 'Mindestalter 65  zu Vertragsbeginn'
}
//-----------------------------------------------------
validators.ageSeniorenMin = (value, component) => {
    //// console.log("@@@@@@@@@@", component)

    var valid = false
    var date_contract = window.moment(component.vertrag_beginn, 'DD.MM.YYYY').startOf('day')
    var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
    var date_minAge_birthday = window.moment(date_input, 'DD.MM.YYYY').add(64, 'years')
    //// console.log("@@@@@@@@@@", date_contract, date_input, component.uvr_altersgruppe)
    valid = (date_minAge_birthday <= date_contract)
    //// console.log('**** VALID? *** 64. Geburtstag:', date_is67.format("DD.MM.YYYY"), "<=  vertrBeginn", date_contract.format("DD.MM.YYYY"), '? =>', valid);

    return valid
}

//=======================================================================================================
errorMsg.age67Max = () => 'Höchstalter 67  zu Vertragsbeginn'
//-----------------------------------------------------
validators.age67Max = (value, component) => {
    //// console.log("@@@@@@@@@@", component)
    var valid = false
    var date_contract = window.moment(component.vertrag_beginn, 'DD.MM.YYYY').startOf('day')
    var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
    var date_is67 = window.moment(date_input, 'DD.MM.YYYY').add(67, 'years')
    //// console.log("@@@@@@@@@@", date_contract, date_input, component.uvr_altersgruppe)
    valid = (date_contract < date_is67)
    //// console.log('**** VALID? *** vertrBeginn:', date_contract.format("DD.MM.YYYY"), "< 67. Geburtstag ", date_is67.format("DD.MM.YYYY"), '? =>', valid);

    return valid

}
//=======================================================================================================
errorMsg.age78Max = () => 'Höchstalter 78 zu Vertragsbeginn'
//-----------------------------------------------------
validators.age78Max = (value, component) => {
    //// console.log("@@@@@@@@@@", component)
    var valid = false
    var date_contract = window.moment(component.vertrag_beginn, 'DD.MM.YYYY').startOf('day')
    var date_input = window.moment(value, 'DD.MM.YYYY').startOf('day')
    var date_is78 = window.moment(date_input, 'DD.MM.YYYY').add(78, 'years')
    //// console.log("@@@@@@@@@@", date_contract, date_input, component.uvr_altersgruppe)
    valid = (date_contract < date_is78)
    //// console.log('**** VALID? *** vertrBeginn:', date_contract.format("DD.MM.YYYY"), "< 78. Geburtstag ", date_is78.format("DD.MM.YYYY"), '? =>', valid);

    return valid

}

/*
//=======================================================================================================
errorMsg.YearMax2YearsAgo = 'Das Jahr darf maximal 2 Jahre in der Vergangenheit liegen';
//-----------------------------------------------------
validators.YearMax2YearsAgo = (value, component) => {

 var valid = false
 // console.log("** VALID? ***", value);
 if (value === "-/-") {
   return valid
 }
 // console.log(parseInt(value, 10) > 2000, parseInt(value, 10) < 2200);

 if (value && value.length === 4 && parseInt(value, 10) > 2000 && parseInt(value, 10) < 2200) {
   value = "31.12." + value;

   // console.log("test result", value, parseInt(value, 10), parseInt(value, 10) > 2000, parseInt(value, 10) < 2200);
   var date_input = moment(value, "DD.MM.YYYY");
   var date_min = moment().subtract(24, 'months');

   valid = (date_min <= date_input)
   // console.log("** VALID? ***", valid, date_min.format("DD.MM.YYYY"), date_input.format("DD.MM.YYYY"));
   // console.log(date_min);
   // console.log(date_input);
 }
 return valid;

}
//=======================================================================================================
*/
validators.errorMsg = errorMsg
validators.xxx = null
export default validators

